<!-- <app-header></app-header>
<app-sidebar></app-sidebar>

<main class="full-wrap">
    <div class="main-div">
        <div class="left-section">
            <div class="row main-row">
                <div class="col-md-12">
                    <div class="main-content">
                        <ng-container *ngIf="dataLength != 0">
                            <div class="market-div" *ngFor="let homeMatch of homeData | keyvalue;let i = index;">
                                <div class="game-header">
                                    <img src="assets/images/icon/DashBoard-icons/{{homeMatch?.key}}.png">
                                    {{homeMatch?.key}}
                                    ({{(homeMatch?.value).length}})
                                </div>
                                <div class="game-body" *ngFor="let matchData of homeMatch.value,let j = index;">
                                    <div class="even-list">
                                        <div class="event-row">

                                            <div class="event-list-item" (click)="matchDetail(matchData)">
                                                <div class="event-info">
                                                    <div class="event-format-strip">
                                                        <div *ngIf="matchData?.inplay == true || matchData?.manualInplay == true"
                                                            class="inplay-div">
                                                            <div class="inplay-btn inplay"><span>InPlay</span> </div>
                                                        </div>
                                                        <div class="event-full-date">
                                                            <span class="date">{{(matchData?.match_date | date :'dd-MM
                                                                hh:mm
                                                                aa')}} IST</span>
                                                        </div>
                                                        <span
                                                            class="event-format-series">{{matchData?.series_name}}</span>
                                                    </div>
                                                    <div class="event-team">
                                                        <div class="team-name">{{matchData?.match_name}}</div>
                                                    </div>
                                                </div>
                                                <div class="url-links">
                                                    <div>
                                                        <div style="margin: 0 10px; font-size: 18px;"
                                                            *ngIf="matchData?.is_lock != false"><a><i
                                                                    class="fa fa-lock"></i></a></div>
                                                        <span class="live-tv" *ngIf="matchData?.sport_id == 4"><img
                                                                src="assets/images/icon/tv.png"></span>
                                                        <span class="live-tv" *ngIf="matchData?.enable_fancy == 1"
                                                            style="margin: 10px;"><i class="fa fa-facebook"
                                                                aria-hidden="true"></i></span>
                                                    </div>
                                                </div>
                                                <div class="event-odds">
                                                    <div class="row">
                                                        <div class="col-sm-4 col-md-4 col-4 text-center">
                                                            <div class="row matchrate">
                                                                <div class="col-sm-6 back-rate back-1">
                                                                    {{matchData?.runners[0] == undefined ? 0 :
                                                                    matchData?.runners[0]?.ex?.availableToBack[0]?.price}}
                                                                </div>
                                                                <div class="col-sm-6 lay-rate lay-1">
                                                                    {{matchData?.runners[0]
                                                                    == undefined ? 0 :
                                                                    matchData?.runners[0]?.ex?.availableToLay[0]?.price}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4 col-md-4 col-4 text-center">
                                                            <div class="row matchrate">
                                                                <div class="col-sm-6 back-rate back-2">
                                                                    {{matchData?.runners[2] == undefined ? '--' :
                                                                    matchData?.runners[2]?.ex?.availableToBack[0]?.price}}
                                                                </div>
                                                                <div class="col-sm-6 lay-rate lay-2">
                                                                    {{matchData?.runners[2]
                                                                    == undefined ? '--' :
                                                                    matchData?.runners[2]?.ex?.availableToLay[0]?.price}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4 col-md-4 col-4 text-center">
                                                            <div class="row matchrate">
                                                                <div class="col-sm-6 back-rate back-3">
                                                                    {{matchData?.runners[1]?.ex?.availableToBack[0]?.price
                                                                    == undefined ? 0 :
                                                                    matchData?.runners[1]?.ex?.availableToBack[0]?.price}}
                                                                </div>
                                                                <div class="col-sm-6 lay-rate lay-3">
                                                                    {{matchData?.runners[1]?.ex?.availableToLay[0]?.price
                                                                    ==
                                                                    undefined ? 0 :
                                                                    matchData?.runners[1]?.ex?.availableToLay[0]?.price}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="suspend" *ngIf="matchData?.status == 'SUSPENDED'">
                                                            <div class="suspend-status">Suspended</div>
                                                        </div>
                                                        <div class="suspend"
                                                            *ngIf="matchData?.status != 'SUSPENDED' && matchData?.is_lock == true">
                                                            <div class="suspend-status">LOCK</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="dataLength == 0">
                            <div class="market-div">No Record Found</div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="right-section">
            <div class="right-sidebar">
                <div class="live-game scroller">
                    <div class="game-header">
                        <img src="assets/images/icon/casino-icon.svg"> Live Casino Games
                    </div>
                    <div class="game-body">
                        <div class="game-inner-list">
                            <div class="list-title">
                                <h3>Live Casino Games</h3>
                            </div>
                            <div class="game-item" *ngFor="let gameList of exchangeGameList;let i = index;"
                                (click)="gotoexchangeGame(gameList)">
                                <div class="thumb">
                                    <img src="assets/Casino/{{gameList?.match_id}}.jpeg">
                                </div>
                                <div class="play-btn">
                                    <a>Play Now</a>
                                </div>
                                <div class="caption text-center">
                                    <h3>{{gameList?.name}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->

<div class="main-wrapper">
    <div class="loading-text" *ngIf="loading == true">
      <div class="loading-wrap" id="loading">
        <ul class="loading">
          <li>
            <div class="loadingio-spinner-dual-ball-srpf31lqtit">
              <div class="ldio-dayih5pen3j">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </li>
          <li>Loading...</li>
        </ul>
      </div>
    </div>
      <app-header></app-header>

      <div class="col-center gamehall">
        <div class="marquee-box">
            <h4>News</h4>
            <div class="marquee">
                <marquee>
                    <a><span>20 Dec 2022</span>Event :- India Women v Australia Women.... Market :- AUSW 6 Over Runs '43-44' (IST 19:07:48 - 19:08:39) , Fall of 2nd WKT AUSW Run Bhav '12.7.11' (IST 19:07:47 - 19:08:47) Bets Voided Because of Wrong Commentary...  Sorry for the Inconvenience Caused</a>
                </marquee>
            </div>
        </div>
        <div class="over-wrap">
          <div class="promo-banner-wrap active">
            <div class="promo-banner">
              <ul class="slides">
                  <li class="banner">
                      <a><img src="assets/sky_img/kv-skyexchang-skyfair-m.jpg" alt=""></a>
                  </li>
              </ul>
            </div>
            <div class="promo-banner-loading" style="display: none;"></div>
          </div>

         
          <div class="gamehall-wrap-simple">
              <a href="">
                  <dl class="on_live">
                      <dt>
                          <p class="live_icon"><span></span> Live</p>
                      </dt>
                      <dd>
                          <p>Cricket</p> <span id="count">3</span>
                      </dd>
                      <dd>
                          <p>Soccer</p> <span id="count">3</span>
                      </dd>
                      <dd>
                          <p>Tennis</p> <span id="count">3</span>
                      </dd>
                      <dd>
                          <p>E-Soccer</p> <span id="count">3</span>
                      </dd>
                      <dd>
                          <p>Kabaddi</p> <span id="count">3</span>
                      </dd>
                  </dl>
                  <dl class="entrance-title">
                      <dt>Sports</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_sports.png" alt="">
              </a>

              <a href="">
                  <dl class="entrance-title">
                      <dt>Kabaddi</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_kabaddi.png" alt="">
              </a>
              <a class="entrance" href="" target="_blank">
                  <img src="assets/sky_img/banner_skyexchangeBlog.png" alt="">
              </a>
              <a href="">
                  <dl class="entrance-title">
                      <dt>Virtual Cricket</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_virtualsports.png" alt="">
              </a>
              <a href="">
                  <dl class="entrance-title">
                      <dt>Live Casino</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_casino.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Blackjack</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_blackjack-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Supernowa</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_supernowa-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>7mojos</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_7mojos-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>HORSEBOOK</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_horsebook-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Minesweeper</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_minesweeper-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Sky Trader</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_skytrader-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>TeenPatti 20-20</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_TeenPatti2020-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>NumberKing</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_NumberKing-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Big small</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_BigSmall-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>TeenPatti Joker</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_TeenPattiJoker-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>7up7down</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_7up7down-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Dragon & Tiger</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_DragonNTiger-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Callbreak Quick</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_CallbreakQuick-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Sic Bo</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_SicBo-Jili-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Baccarat</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_Baccarat-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Bonus Dice</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_BonusDice-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Heist</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_Heist-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>5 Card Poker</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_5CardPoker-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Color Game</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_ColorGame-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>32 Cards</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_32card-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Rummy</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_rummy-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>BetGames</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_betgames-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Andar Bahar</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_andarBahar-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Sicbo</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_sicbo-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>7 UP 7 Down</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_sevenUpDown-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Coin Toss</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_CoinToss-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Teen Patti</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_teenPatti-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Card Matka</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_cardMatka-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Number Matka</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_numberMatka-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Binary</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_binary-half.png" alt="">
              </a>
              <a href="" class="entrance-half">
                  <dl class="entrance-title">
                      <dt>Bpoker</dt>
                      <dd>Play Now</dd>
                  </dl>
                  <img src="assets/sky_img/banner_bpoker-half.png" alt="">
              </a>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
      <app-footer-main></app-footer-main>
  </div>
  
 <!-- Non Gambling Modal -->
<ng-template #loginCnfm>
<div> 
    <div class="modal-header border-bottom-0 pb-0">
        <a aria-label="Close" class="close"  data-bs-dismiss="modal" aria-label="Close"
        (click)="modalRef.hide()">×</a>
    </div>
    <div class="modal-body text-center">
        <div class="confirm-text">
            <div class="text1">Non-Gambling Territories.</div>
            <hr class="confirm-line">
            <div class="text2">Connecting to our site from non gambling countries, it will be User's
                responsibility to ensure that their use of the service is lawful.</div>
        </div>
        <div class="confirm-text mb-3">
            <div class="text1">Underage gambling is prohibited.</div>
            <hr class="confirm-line">
            <div class="text2">Please confirm if you are 18 years old and above as of today.</div>
        </div>
        <div class="modal-footer border-top-0 justify-content-center">
            <button class="btn btn-light" data-bs-target="#loginModal"
                data-bs-toggle="modal" (click)="modalRef.hide();openModalLoginPopup(loginPopup)">Confirm</button>
            <button type="button" class="btn btn-outline-light" data-bs-dismiss="modal" (click)="modalRef.hide();">Exit</button>
        </div>
    </div>
</div>
</ng-template>
<!-- Login Modal -->
<ng-template #loginPopup>
    <a aria-label="Close" class="close"  data-bs-dismiss="modal" aria-label="Close"
        (click)="modalRef.hide()">×</a>
    <div class="login-head d-block d-lg-none">
        <div class="logo-holder"><img src="{{logo}}" alt=""></div>
    </div>
    <div class="dialog-wrap-w login_to_go image-block">
        <div class="kv d-none d-lg-block">
            <div class="overlay-logo">
            <img src="{{logo}}" alt="">
            </div>
        </div>
        <div class="login-panel">
            <form action="" [formGroup]='Form' novalidate="">
                <h5>Please login to continue</h5>
                <div class="form-group">
                    <input formControlName="user_name" class="form-control"
                    placeholder="UserName" required="" type="text">
                </div>
                <div class="form-group">
                    <input formControlName="password" class="form-control"
                    placeholder="Password" required="" type="password">
                </div>
                <span class="err-invalid-modal error-message">{{showResponseMessage}}</span>
                <div class="form-group">
                    <button class="btn btn-send" type="submit" (click)="onSubmitLogin()" style="color: #000;">Login</button>
                </div>
            </form>
        </div>
    </div>
<!-- </modal-container> -->
</ng-template>
  <!-- Search Modal -->
  <ng-template #search>
    <div ngbDropdown class="search-top dropdown">
      <form class="d-flex position-relative">
          <span class="float-icon search-icon" style="color:#000 !important"><i class="bi bi-search"></i></span>
          <input ngbDropdownToggle class="form-control" id="dropdownMenuLink"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
          [(ngModel)]="searchSport" [ngModelOptions]="{standalone: true}">
          <span class="float-icon clearall-icon" (click)="searchSport = '';modalRef.hide()" ><i class="bi bi-x-lg"></i></span>
          <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a ngbDropdownItem class="dropdown-item" *ngFor="let sport of homeData |search: searchSport :'match_name'">
                  <div class="event-info" (click)="matchDetailDrop(sport)">
                      <div class="event-team">
                          <div class="team-name">{{sport?.match_name}}</div>
                      </div>
                  </div>
              </a>
          </div>
          
      </form>                    
    </div>
  </ng-template>
  

